import { render, staticRenderFns } from "./OrgUnit.vue?vue&type=template&id=729b5aa8&scoped=true"
import script from "./OrgUnit.vue?vue&type=script&lang=js"
export * from "./OrgUnit.vue?vue&type=script&lang=js"
import style0 from "./OrgUnit.vue?vue&type=style&index=0&id=729b5aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729b5aa8",
  null
  
)

export default component.exports